<!--
  语言切换组件
-->
<template>
  <ul class="langWrap">
    <li
      v-for="(lan,index) in langGroups"
      :key="index"
      :class="{'active':lang === lan.value}"
      @click="switchLang(lan.value)"
    >
      <span>
        {{ lan.name }}
      </span>
      <div v-if="lang === lan.value" class="selected-indicator"></div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LangRadio',
  props: {
    visibleMoreLang: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lang: localStorage.getItem('locale') || 'zh'
    }
  },
  computed: {
    langGroups () {
      const group = [
        { value: 'zh', name: '中文' },
        { value: 'en', name: 'EN' }
      ]

      if (this.visibleMoreLang) {
        return [
          ...group,
          { value: 'ja', name: '日本語' },
          { value: 'ko', name: '한국어' }
        ]
      }

      return group;
    }
  },
  created () {
    const lang = localStorage.getItem('locale') || 'zh'

    if (!this.visibleMoreLang) {
      if (['ja', 'ko'].includes(lang)) {
        this.switchLang('zh')
        return;
      }
    }

    this.switchLang(lang)
  },
  methods: {
    switchLang (lang) { // 调用computed里的set方法
      localStorage.setItem('locale', lang) // 设置本地storage语言
      this.lang = lang // 设置i18n切换语言显示
      this.$i18n.locale = lang // 设置i18n切换语言显示
      document.title = this.$t('title')
      this.$emit('query')
    }
  }
}
</script>
<style lang="less">
  .langWrap{
    display: flex;
    position: relative;
    li{
      .selected-indicator {
        position: absolute;
        bottom: 10px;
        width: 54px;
        height: 16px;
        background-image: url('../assets/images/Selected_text.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      min-width: 153px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FFFFFF;
      border-radius: 43px;
      border: 2px solid #E1F1F8;
      margin-right: 21px;
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        line-height: 40px;
        font-size: 28px;
        color: #86949E;
        text-align: center;
        font-style: normal;
        line-height: 40px;
        z-index: 10;
      }

      &.active{
        border: 2px solid #A2E9ED;
        span {
          font-size: 26px;
          font-weight: 500;
          line-height: 37px;
          color: #36444E;
        }

        &::after {
          display: none;
        }
      }

      &::after {
        content: ' ';
        width: 1PX;
        height: 72%;
        top: 50%;
        right: -1PX;
        transform: translateY(-50%);
        background: #ffffff;
        position: absolute;
      }

      &:last-child {
        &::after {
          display: none;
        }
      }
      &:first-child{
      }
    }

  }
</style>
